export default __webpack_public_path__ + "assets/json/0674d7c6f7bb8562db3f1d640cddb394.json";